import { action, makeAutoObservable } from "mobx";
import { IShortTask } from "../../models/ticket";
import { TaskService } from "../../services/task-service";
import { message } from "antd";

export default class ShortTaskStore {

    task: IShortTask;

    mathTaskService: TaskService;

    constructor(task: IShortTask) {
        this.task = task;
        this.mathTaskService = new TaskService();

        makeAutoObservable(this);
    }

    @action
    updateAnswer(value: string) {
        this.task.answer = value;
    }

    @action
    saveAnswer() {

        if (this.task.answer) {
            this.mathTaskService.updateAnswer(
                this.task.id, this.task.answer,
                () => message.success("Ответ успешно сохранён!")
            );
        }
    }
}